import React from "react";
import { Script } from "gatsby";

import { useLiveChat } from "~/hooks/useLiveChat";

export function LiveChatScripts() {
  const { enabled, key } = useLiveChat();

  if (!enabled) return null;

  return (
    <Script
      id="ze-snippet"
      strategy="idle"
      src={`https://static.zdassets.com/ekr/snippet.js?key=${key}`}
    />
  );
}

declare global {
  interface Window {
    /**
     * Attached to window by Zendesk live chat script.
     * @see https://developer.zendesk.com/api-reference/widget-messaging/web/core
     */
    zE?: (
      arg1: "messenger",
      action: "show" | "hide" | "open" | "close",
    ) => void;
    /**
     * Convenience method added in gatsby-browser.
     * Used by custom onClick handlers in Sanity content.
     */
    LiveChat?: {
      open: () => void;
    };
  }
}
